import { render, staticRenderFns } from "./top-theme.vue?vue&type=template&id=1bd7f21a&scoped=true&"
import script from "./top-theme.vue?vue&type=script&lang=js&"
export * from "./top-theme.vue?vue&type=script&lang=js&"
import style0 from "./top-theme.vue?vue&type=style&index=0&id=1bd7f21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7f21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd7f21a')) {
      api.createRecord('1bd7f21a', component.options)
    } else {
      api.reload('1bd7f21a', component.options)
    }
    module.hot.accept("./top-theme.vue?vue&type=template&id=1bd7f21a&scoped=true&", function () {
      api.rerender('1bd7f21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-theme.vue"
export default component.exports